import React, { useEffect, useState, useContext } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import { Container } from '@mui/system';
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody, tableCellClasses } from '@mui/material';
import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import LoaderDialog from './LoaderDialog'
import { AuthContext } from "../authContext/AuthContext";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const LineChartSalesman = ({startDate, endDate}) => {
  const [labels, setLabels] = useState();
  const [amounts, setAmounts] = useState();
  const [resData, setResData] = useState();
  const [loading, setLoading] = useState(false);
  const { user, shop } = useContext(AuthContext);

  useEffect(() => {
    const loadData = async() => {
      try {
        setLoading(true)
        let d = new Date(endDate)
        d.setDate(d.getDate() + 1)
        const newEndDate = d.toISOString().split('T')[0]
        const res = await axios.post("/orders/salesperson", {startDate, endDate: newEndDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        const label=[]
        const amt=[]
        res.data.map(item => {
          label.push(item._id)
          return amt.push(item.total)
        });
        setLabels(label);
        setAmounts(amt);
        setResData(res.data);
        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }
    loadData();
  },[startDate, endDate, user, shop]);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: "Sales Person Wise Sales Report",
      },
    },
  };
  const data = {
    labels,
    'datasets': [
      {
        label: "Sales Person Wise Sales",
        data: amounts,
        backgroundColor: '#118DFF',
      }
    ]
  };
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#1776d1',
      color: 'white',
    }
  }));
  return (
    <Container maxWidth="false" disableGutters sx={{height: "85vh", width: "100vw"}}>
      <LoaderDialog open={loading} title="Loading Report Data ..."/>
      <Grid container>
        <Grid item xs={6} sx={{ padding: 1}}>
          <Bar data={data} options={options}/>
        </Grid>
        <Grid item xs={6} sx={{padding: 1}}>
        {resData && 
        <TableContainer>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>#</StyledTableCell>
              <StyledTableCell>User</StyledTableCell>
              <StyledTableCell>Bills</StyledTableCell>
              <StyledTableCell>Total</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {resData.map((item, index) => (
              <TableRow key={item._id}>
                <StyledTableCell>{index + 1}</StyledTableCell>
                <StyledTableCell>{item._id}</StyledTableCell>
                <StyledTableCell>{item.count}</StyledTableCell>
                <StyledTableCell>{item.total}</StyledTableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>      
        </TableContainer>}
        </Grid>
      </Grid>
    </Container>
  )
}

export default LineChartSalesman
